import { AppForm } from '../../../../../../../common/forms/app.form';
import { inject, Injectable, Signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import { map, of, switchMap, tap } from 'rxjs';
import { AddressLocationsService, AddressStreetsService } from '../../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RegistrationForTheSewageTreatmentPlantRegisterForm extends AppForm {

  private addressStreetService: AddressStreetsService = inject(AddressStreetsService);

  private addressLocationService: AddressLocationsService = inject(AddressLocationsService);

  public cityList: Signal<string[] | undefined> = toSignal(
    this.addressLocationService.getAddressLocationsAddressLocationsItem().pipe(
      map((v) => v?.names || [])
    )
  );

  public streetList: Signal<string[] | undefined> = toSignal(
    this.city.valueChanges.pipe(
      switchMap((locality: string) => this.addressStreetService.getAddressStreetsAddressStreetsItem({
        locality
      }).pipe(
        map((v) => v?.names || []),
        catchError((err: Error) => of([]))
      ))
    )
  );

  public treatmentPlantTypes: string[] = [
    'Biologiczna',
    'Drenażowa',
    'Z osadem czynnym'
  ];

  constructor() {
    super({
      city: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      street: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      houseNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),

      treatmentPlantType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),

      treatmentPlantCapacity: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      treatmentPlantCommissioningDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] })
    });
  }

  private get city(): FormControl {
    return this.get('city') as FormControl;
  }

  private get street(): FormControl {
    return this.get('street') as FormControl;
  }

  public cityChange(): void {
    this.street.setValue('', { emitEvent: false });
  }
}
